import {fetchPrivateMedia, mediaExtension} from '../../helpers/privateMedia';
import React, {useEffect, useRef, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Title from '../dashboard/Title';
import UserService from "../../services/user.service";
import {logOut} from "../../helpers/logout";
import useTable from "./useTable";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import {InputAdornment} from "@material-ui/core";
import Badge from "@material-ui/core/Badge";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Popover from "@material-ui/core/Popover";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import FilterListIcon from "@material-ui/icons/FilterList";
import GraphicEqIcon from "@material-ui/icons/GraphicEq";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import TextInput from "../form/input/TextInput";
import SelectInput from "../form/input/SelectInput";
import {Search} from "@material-ui/icons";
import Time from "react-time-format";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import {Redirect} from "react-router-dom";
import ActionButton from "../form/input/ActionButton";
import InfoIcon from '@material-ui/icons/Info';
import EuroIcon from '@material-ui/icons/Euro';
import DeleteIcon from '@material-ui/icons/Delete';
import PhoneIcon from '@material-ui/icons/Phone';
import SaveIcon from '@material-ui/icons/Save';
import {NotificationManager} from 'react-notifications';
import ConfirmDialog from "./ConfirmDialog";
import Popup from "./Popup";
import LoadingOverlay from "./LoadingOverlay";
import Tooltip from "@material-ui/core/Tooltip";
import JSZip from "jszip";
import {saveAs} from "file-saver";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {useDashboardStyles, BRAND} from "../settings/dashboardStyles";
import {getAccess} from "../../helpers/permissions";

const getSupportedAudioMimeType = () => {
    if (!window.MediaRecorder || !MediaRecorder.isTypeSupported) return '';
    return ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/mpeg', 'audio/wav']
        .find((mimeType) => MediaRecorder.isTypeSupported(mimeType)) || '';
};

const audioExtensionFromMimeType = (mimeType) => {
    const mime = (mimeType || '').toLowerCase();
    if (mime.includes('webm')) return 'webm';
    if (mime.includes('mp4')) return 'mp4';
    if (mime.includes('aac')) return 'aac';
    if (mime.includes('mpeg') || mime.includes('mp3')) return 'mp3';
    if (mime.includes('wav')) return 'wav';
    return 'webm';
};

const useLocalStyles = makeStyles((theme) => ({
    toolbar: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
        flexWrap: "wrap",
    },
    searchInput: {
        flex: "1 1 320px",
        minWidth: 240,
    },
    filterButton: {
        background: "#ffffff",
        color: BRAND.deep,
        border: `1.5px solid ${BRAND.goldSoft}`,
        borderRadius: 8,
        textTransform: "none",
        fontWeight: 600,
        padding: theme.spacing(0.9, 1.75),
        "&:hover": {
            background: BRAND.goldBg,
            borderColor: BRAND.gold,
        },
    },
    smartButton: {
        background: BRAND.deep,
        color: "#ffffff",
        borderRadius: 8,
        textTransform: "none",
        fontWeight: 700,
        padding: theme.spacing(0.9, 1.75),
        "&:hover": {
            background: "#24384a",
        },
    },
    smartActiveNotice: {
        width: "100%",
        color: BRAND.deep,
        fontWeight: 600,
        fontSize: "0.85rem",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        flexWrap: "wrap",
    },
    smartResetButton: {
        color: BRAND.deep,
        borderColor: BRAND.goldSoft,
        textTransform: "none",
        fontWeight: 700,
        padding: theme.spacing(0.25, 1),
        minWidth: "auto",
        "&:hover": {
            background: BRAND.goldBg,
            borderColor: BRAND.gold,
        },
    },
    aiModalWrap: {
        position: "relative",
        minHeight: 220,
    },
    aiLoadingOverlay: {
        position: "absolute",
        inset: 0,
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(1),
        background: "rgba(255,255,255,0.72)",
    },
    aiModalContentLoading: {
        opacity: 0.45,
        pointerEvents: "none",
    },
    aiNotice: {
        color: "#5a6675",
        marginBottom: theme.spacing(2),
        lineHeight: 1.55,
    },
    warningText: {
        color: "#a8324a",
        fontWeight: 700,
        marginBottom: theme.spacing(1),
    },
    columnPanel: {
        padding: theme.spacing(2),
        width: 280,
    },
    columnPanelTitle: {
        color: BRAND.deep,
        fontWeight: 700,
        marginBottom: theme.spacing(0.5),
    },
    columnPanelHint: {
        color: "#5a6675",
        fontSize: "0.8rem",
        marginBottom: theme.spacing(1.5),
    },
    columnList: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.25),
        marginTop: theme.spacing(1),
    },
    columnOption: {
        marginLeft: 0,
        marginRight: 0,
        color: "#1a2733",
    },
    paidYes: {
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 9px",
        background: BRAND.successBg,
        color: BRAND.success,
        borderRadius: 999,
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        border: `1px solid ${BRAND.successBorder}`,
    },
    paidNo: {
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 9px",
        background: "rgba(248, 50, 69, 0.08)",
        color: "#a8324a",
        borderRadius: 999,
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        border: "1px solid rgba(248, 50, 69, 0.22)",
    },
    footer: {
        marginTop: theme.spacing(1.5),
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: theme.spacing(1),
    },
    flexGrow: {
        flexGrow: 1,
    },
    actionsCell: {
        whiteSpace: "nowrap",
        width: 1,
    },
    actionsRow: {
        display: "inline-flex",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(0.5),
    },
}));

export default function FullList(props) {
    const classes = useDashboardStyles();
    const localClasses = useLocalStyles();
    const access = getAccess();

    const[year, setYear ] = useState('2024');
    const[month, setMonth ] = useState('1');

    const[downloadCount, setDownloadCount ] = useState(0);
    const[downloader, setDownloader ] = useState(0);

    const [funerals, setFunerals] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filterYear, setFilterYear] = useState('');
    const [filterMonth, setFilterMonth] = useState('');
    const [filterWeek, setFilterWeek] = useState('');
    const [filterAutopsy, setFilterAutopsy] = useState('');
    const [tempFilterYear, setTempFilterYear] = useState('');
    const [tempFilterMonth, setTempFilterMonth] = useState('');
    const [tempFilterWeek, setTempFilterWeek] = useState('');
    const [tempFilterAutopsy, setTempFilterAutopsy] = useState('');
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const [columnPanelAnchor, setColumnPanelAnchor] = useState(null);
    const [hiddenColumnIds, setHiddenColumnIds] = useState(() => {
        try {
            const savedHiddenColumns = localStorage.getItem('fullListHiddenColumns');
            return savedHiddenColumns ? JSON.parse(savedHiddenColumns) : ['autopsy'];
        } catch (e) {
            return ['autopsy'];
        }
    });
    const [filterFn, setFilterFn] = useState({
        fn: items => {
            return items;
        }
    })
    const [list, setList] = useState(false);
    const [funeralDetail, setFuneralDetail] = useState(null);
    const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''})
    const [confirmDialog2, setConfirmDialog2] = useState({isOpen: false, title: '', subTitle: '', color: 'primary'})
    const [confirmDialog3, setConfirmDialog3] = useState({isOpen: false, title: '', subTitle: '', color: 'primary'})
    const [confirmDialog4, setConfirmDialog4] = useState({isOpen: false, title: '', subTitle: '', color: 'primary'})
    const [limit, setLimit] = useState(100);
    const [success, setSuccess] = useState(null);
    const [user, setUser] = useState(null);
    const [smartSearchOpen, setSmartSearchOpen] = useState(false);
    const [smartSearchText, setSmartSearchText] = useState('');
    const [smartSearchActive, setSmartSearchActive] = useState(false);
    const [smartSearchSummary, setSmartSearchSummary] = useState('');
    const [smartSearchLoading, setSmartSearchLoading] = useState(false);
    const [smartSearchRecording, setSmartSearchRecording] = useState(false);
    const smartSearchMediaRecorderRef = useRef(null);
    const smartSearchAudioChunksRef = useRef([]);

    const autopsyOptions = [
        {value: '', title: 'Všetky možnosti'},
        {value: 'NIE', title: 'NIE'},
        {value: 'ÁNO, Urobili sme zvoz a MÁME POHREB', title: 'ÁNO, Urobili sme zvoz a MÁME POHREB'},
        {value: 'ÁNO, INÁ pohrebná služba urobila zvoz a MÁME POHREB', title: 'ÁNO, INÁ pohrebná služba urobila zvoz a MÁME POHREB'},
        {value: 'ÁNO, urobili sme zvoz a NEMÁME POHREB', title: 'ÁNO, urobili sme zvoz a NEMÁME POHREB'},
    ];

    const columnDefinitions = [
        {id: 'deceased', label: 'Zosnulý'},
        {id: 'd_death', label: 'Dátum úmrtia'},
        {id: 'date_funeral', label: 'Pohreb'},
        {id: 'ca_phone', label: 'Kontakt', disableSorting: true},
        {id: 'paid', label: 'Zaplatený'},
        ...(access.seePrices && user && user.iban && user.next_invoice_number ? [{id: 'invoice', label: 'Faktúra', disableSorting: true}] : []),
        {id: 'autopsy', label: <span>Pitva <Tooltip title="Slúži pre pohrebné služby, ktoré vozia na pitvu."><HelpOutlineIcon style={{ fontSize: 18, verticalAlign: 'middle', cursor: 'pointer' }} /></Tooltip></span>},
    ];

    const visibleColumns = columnDefinitions.filter(column => !hiddenColumnIds.includes(column.id));
    const headCells = [
        ...visibleColumns,
        {id: 'actions', label: 'Akcie', disableSorting: true, align: 'right'}
    ];

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(funerals, headCells, filterFn);

    const loadDefaultFunerals = () => {
        return UserService.getListFunerals(limit).then(
            (response) => {
                setFunerals(response.data);
            },
            (e) => {
                if (e.response && e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    };

    const resetSmartSearch = (reload = true) => {
        if (!smartSearchActive) return;
        setSmartSearchActive(false);
        setSmartSearchSummary('');
        if (reload) {
            loadDefaultFunerals();
        }
    };

    useEffect(() => {
        const user_local = JSON.parse(localStorage.getItem('user')).id;
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
            },
            (e) => {
                if (e.response?.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
        UserService.getListFunerals(limit).then(
            (response) => {
                setFunerals(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [limit, props]);

    const getWeekNumber = (date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));
        const yearStart = new Date(d.getFullYear(), 0, 1);
        const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
        return weekNo;
    };

    const applyFilters = () => {
        setFilterFn({
            fn: items => items.filter(x => {
                // Text search filter
                const regex = new RegExp(searchText, 'i');
                const matchesText = !searchText || 
                    x.deceased.match(regex) ||
                    x.contracting_authority.match(regex) ||
                    x.town_funeral.match(regex) ||
                    x.d_id.match(regex);

                // Year filter
                const funeralYear = x.date_funeral ? new Date(x.date_funeral).getFullYear().toString() : '';
                const matchesYear = !filterYear || funeralYear === filterYear;

                // Month filter
                const funeralMonth = x.date_funeral ? (new Date(x.date_funeral).getMonth() + 1).toString() : '';
                const matchesMonth = !filterMonth || funeralMonth === filterMonth;

                // Week filter
                const funeralWeek = x.date_funeral ? getWeekNumber(x.date_funeral).toString() : '';
                const matchesWeek = !filterWeek || funeralWeek === filterWeek;

                // Autopsy filter
                const autopsy = x.evidence && x.evidence.autopsy ? x.evidence.autopsy : '';
                const matchesAutopsy = !filterAutopsy || autopsy === filterAutopsy;

                return matchesText && matchesYear && matchesMonth && matchesWeek && matchesAutopsy;
            })
        });
    };

    useEffect(() => {
        applyFilters();
        // eslint-disable-next-line
    }, [searchText, filterYear, filterMonth, filterWeek, filterAutopsy, funerals]);

    const handleSearch = e => {
        resetSmartSearch();
        setSearchText(e.target.value);
    };

    const handleYearFilter = e => {
        resetSmartSearch();
        setFilterYear(e.target.value);
    };

    const handleMonthFilter = e => {
        resetSmartSearch();
        setFilterMonth(e.target.value);
    };

    const handleWeekFilter = e => {
        resetSmartSearch();
        setFilterWeek(e.target.value);
    };

    const handleOpenFilterModal = () => {
        setTempFilterYear(filterYear);
        setTempFilterMonth(filterMonth);
        setTempFilterWeek(filterWeek);
        setTempFilterAutopsy(filterAutopsy);
        setFilterModalOpen(true);
    };

    const handleApplyFilters = () => {
        resetSmartSearch();
        setFilterYear(tempFilterYear);
        setFilterMonth(tempFilterMonth);
        setFilterWeek(tempFilterWeek);
        setFilterAutopsy(tempFilterAutopsy);
        setFilterModalOpen(false);
    };

    const handleClearFilters = () => {
        resetSmartSearch();
        setTempFilterYear('');
        setTempFilterMonth('');
        setTempFilterWeek('');
        setTempFilterAutopsy('');
        setFilterYear('');
        setFilterMonth('');
        setFilterWeek('');
        setFilterAutopsy('');
        setFilterModalOpen(false);
    };

    const resetSmartModalInputs = () => {
        setSmartSearchText('');
        setSmartSearchRecording(false);
        smartSearchAudioChunksRef.current = [];
        smartSearchMediaRecorderRef.current = null;
    };

    const handleCloseSmartSearchModal = () => {
        if (smartSearchRecording && smartSearchMediaRecorderRef.current) {
            smartSearchMediaRecorderRef.current.stop();
        }
        resetSmartModalInputs();
        setSmartSearchOpen(false);
    };

    const applySmartSearch = (text) => {
        const cleanText = (text || '').trim();
        if (!cleanText) {
            NotificationManager.warning('Najprv zadajte text alebo potvrďte prepis.', 'Smart vyhľadávanie', 5000);
            return;
        }

        setSmartSearchLoading(true);
        UserService.smartSearchFuneralsWithAi({text: cleanText}).then(
            (response) => {
                const resultFunerals = response.data && response.data.funerals ? response.data.funerals : [];
                setSearchText('');
                setFilterYear('');
                setFilterMonth('');
                setFilterWeek('');
                setFilterAutopsy('');
                setTempFilterYear('');
                setTempFilterMonth('');
                setTempFilterWeek('');
                setTempFilterAutopsy('');
                setSmartSearchActive(true);
                setSmartSearchSummary(cleanText);
                setFunerals(resultFunerals);
                setFilterFn({fn: items => items});
                setSmartSearchLoading(false);
                setSmartSearchOpen(false);
                resetSmartModalInputs();
                NotificationManager.success(`Smart vyhľadávanie našlo ${resultFunerals.length} záznamov.`, 'Smart vyhľadávanie', 5000);
                if (response.data && response.data.warnings && response.data.warnings.length) {
                    NotificationManager.warning(response.data.warnings.join(' '), 'AI upozornenie', 7000);
                }
            },
            (e) => {
                setSmartSearchLoading(false);
                if (e.response && e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                } else {
                    NotificationManager.error('Smart vyhľadávanie zlyhalo. Skúste neskôr.', 'Chyba', 5000);
                }
            }
        );
    };

    const startSmartSearchRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({audio: true});
            const mimeType = getSupportedAudioMimeType();
            const recorder = new MediaRecorder(stream, mimeType ? {mimeType} : undefined);
            smartSearchAudioChunksRef.current = [];
            smartSearchMediaRecorderRef.current = recorder;

            recorder.ondataavailable = (event) => {
                if (event.data && event.data.size > 0) {
                    smartSearchAudioChunksRef.current.push(event.data);
                }
            };

            recorder.onstop = () => {
                stream.getTracks().forEach((track) => track.stop());
                const recordedMimeType = recorder.mimeType || mimeType || 'audio/webm';
                const blob = new Blob(smartSearchAudioChunksRef.current, {type: recordedMimeType});
                const formData = new FormData();
                formData.append('audio', blob, `smart-search-audio.${audioExtensionFromMimeType(recordedMimeType)}`);
                setSmartSearchLoading(true);
                UserService.transcribeFuneralAudioWithAi(formData).then(
                    (response) => {
                        setSmartSearchText(response.data.transcript || '');
                        setSmartSearchLoading(false);
                    },
                    (e) => {
                        setSmartSearchLoading(false);
                        if (e.response && e.response.status === 401) {
                            logOut(props);
                            NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                        } else {
                            NotificationManager.error('Prepis nahrávky zlyhal. Skúste neskôr.', 'Chyba', 5000);
                        }
                    }
                );
            };

            recorder.start();
            setSmartSearchRecording(true);
        } catch (e) {
            NotificationManager.error('Nepodarilo sa spustiť mikrofón.', 'Chyba', 5000);
        }
    };

    const stopSmartSearchRecording = () => {
        if (smartSearchMediaRecorderRef.current && smartSearchRecording) {
            smartSearchMediaRecorderRef.current.stop();
            setSmartSearchRecording(false);
        }
    };

    const getActiveFilterCount = () => {
        let count = 0;
        if (filterYear) count++;
        if (filterMonth) count++;
        if (filterWeek) count++;
        if (filterAutopsy) count++;
        return count;
    };

    const handleOpenColumnPanel = (event) => {
        setColumnPanelAnchor(event.currentTarget);
    };

    const handleCloseColumnPanel = () => {
        setColumnPanelAnchor(null);
    };

    const handleToggleColumn = (columnId) => {
        const isHidden = hiddenColumnIds.includes(columnId);
        if (!isHidden && visibleColumns.length <= 1) {
            return;
        }

        const nextHiddenColumnIds = isHidden
            ? hiddenColumnIds.filter(id => id !== columnId)
            : [...hiddenColumnIds, columnId];

        setHiddenColumnIds(nextHiddenColumnIds);
        localStorage.setItem('fullListHiddenColumns', JSON.stringify(nextHiddenColumnIds));
    };

    const isColumnVisible = (columnId) => !hiddenColumnIds.includes(columnId);

    const handleDelete = (id) => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
        UserService.deleteFuneral(id).then(
            () => {
                NotificationManager.success('Pohreb bol presunutý do koša.', 'Presunuté', 5000);
                UserService.getListFunerals(limit).then(
                    (response) => {
                        setFunerals(response.data);
                    },
                    (e) => {
                        if (e.response.status === 401) {
                            logOut(props);
                            NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                        }
                    }
                );
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                NotificationManager.error('Pohreb sa nepodarilo odstrániť!', 'Chyba', 5000);
            }
        );
    }

    const handleRedirect = () => {
        setList(true);
    }

    const handleNoLimit = () => {
        setLimit(0);
    }

    const changePaidStatus = (id) => {
        setConfirmDialog2({
            ...confirmDialog2,
            isOpen: false
        })
        UserService.getFuneral(id).then(
            (response) => {
                let object = response.data;
                object.funeral_paid = !object.funeral_paid;
                UserService.updateFuneral(object).then(
                    (response) => {
                        setSuccess(response.data._id);
                        UserService.getListFunerals(limit).then(
                            (response) => {
                                setFunerals(response.data);
                            },
                            (e) => {
                                if (e.response.status === 401) {
                                    logOut(props);
                                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                                }
                            }
                        );
                        NotificationManager.success('Pohreb bol upravený!', 'Vytvorené', 5000);
                    },
                    (e) => {
                        if (e.response.status === 401) {
                            logOut(props);
                            NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                        } else {
                            NotificationManager.error('Došlo k neočakávanej chybe. Skúste neskôr alebo kontaktujte podporu.', 'Chyba', 5000);
                        }
                    }
                );
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }
    

    const handleDownload = async () => {
        setConfirmDialog3((current) => ({...current, isOpen: false}));
        setConfirmDialog4({isOpen: true, title: 'Čakajte kým sa načítajú všetky údaje.'});
        setDownloader(0);
        try {
            const year = document.getElementsByName('year')[0].value;
            const month = document.getElementsByName('month')[0].value;
            const response = await UserService.getListFuneralsDownload(year, month);
            setDownloadCount(response.data.length);
            const zip = new JSZip();
            for (const item of response.data) {
                const folderName = `${(item.deceased || 'pohreb').replace(/[\\/]/g, '_')}-${item._id}`;
                const folder = zip.folder(folderName);
                folder.file('data.txt', JSON.stringify(item));
                // Media references come from the authenticated backend presenter, including signatures.
                const sources = [...Object.entries(item), ...Object.entries(item.signatures || {})]
                    .filter(([, value]) => typeof value === 'string' && value.startsWith('/api/media/'));
                for (const [field, source] of sources) {
                    const file = await fetchPrivateMedia(source);
                    folder.folder('prilohy').file(`${field}.${mediaExtension(file)}`, await file.blob());
                }
                setDownloader((current) => current + 1);
            }
            const content = await zip.generateAsync({type: 'blob'});
            saveAs(content, `MP-${year}-${month}.zip`);
        } catch (error) {
            if (error.response?.status === 401) logOut(props);
            NotificationManager.error('Export sa nepodarilo dokončiť. Skúste to znova.', 'Chyba', 5000);
        } finally {
            setDownloader(0);
            setConfirmDialog4((current) => ({...current, isOpen: false}));
        }
    };

    return (
        <React.Fragment>
            <Container maxWidth="lg" className={classes.pageContainer}>
                <Paper className={classes.paper} elevation={0}>
                    <div className={classes.sectionHeader}>
                        <Title>Zoznam pohrebov</Title>
                        <div className={classes.sectionToolbar}>
                            {access.write && <Button
                                startIcon={<AddIcon/>}
                                className={classes.primaryAction}
                                onClick={handleRedirect}
                            >
                                Vytvoriť pohreb
                            </Button>}
                        </div>
                    </div>

                    <div className={localClasses.toolbar}>
                        <div className={localClasses.searchInput}>
                            <TextInput
                                label="Vyhľadať podľa mena"
                                InputProps={{
                                    startAdornment: (<InputAdornment position="start"><Search/></InputAdornment>)
                                }}
                                onChange={handleSearch}
                                value={searchText}
                                fullWidth
                            />
                        </div>
                        <Button
                            startIcon={
                                <Badge badgeContent={smartSearchActive ? 1 : 0} color="secondary" overlap="rectangular">
                                    <GraphicEqIcon/>
                                </Badge>
                            }
                            onClick={() => setSmartSearchOpen(true)}
                            className={localClasses.smartButton}
                        >
                            Smart vyhľadávanie
                        </Button>
                        <Button
                            startIcon={<ViewColumnIcon/>}
                            onClick={handleOpenColumnPanel}
                            className={localClasses.filterButton}
                        >
                            Stĺpce
                        </Button>
                        <Button
                            startIcon={
                                <Badge badgeContent={getActiveFilterCount()} color="secondary" overlap="rectangular">
                                    <FilterListIcon/>
                                </Badge>
                            }
                            onClick={handleOpenFilterModal}
                            className={localClasses.filterButton}
                        >
                            Filtrovať
                        </Button>
                        {smartSearchActive && (
                            <Typography component="div" className={localClasses.smartActiveNotice}>
                                <span>Smart vyhľadávanie je aktívne: „{smartSearchSummary}“. Použitie bežných filtrov ho zruší.</span>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    className={localClasses.smartResetButton}
                                    onClick={() => resetSmartSearch(true)}
                                >
                                    Zrušiť smart filter
                                </Button>
                            </Typography>
                        )}
                    </div>

                    {funerals.length === 0 ? (
                        <div className={classes.emptyState}>
                            Zatiaľ nie sú zaznamenané žiadne pohreby.
                        </div>
                    ) : (
                        <>
                            <TblContainer>
                                <TblHead/>
                                <TableBody>
                                    {recordsAfterPagingAndSorting().map((item, index) => (
                                        <TableRow key={index}>
                                            {isColumnVisible('deceased') && <TableCell><strong>{item.deceased}</strong></TableCell>}
                                            {isColumnVisible('d_death') && <TableCell><Time value={item.d_death} format="DD.MM.YYYY HH:mm"/></TableCell>}
                                            {isColumnVisible('date_funeral') && <TableCell><Time value={item.date_funeral} format="DD.MM.YYYY HH:mm"/></TableCell>}
                                            {isColumnVisible('ca_phone') && <TableCell>{item.ca_phone}</TableCell>}
                                            {isColumnVisible('paid') && (
                                                <TableCell>
                                                    <span className={item.funeral_paid ? localClasses.paidYes : localClasses.paidNo}>
                                                        {item.funeral_paid ? 'Áno' : 'Nie'}
                                                    </span>
                                                </TableCell>
                                            )}
                                            {access.seePrices && user && user.iban && user.next_invoice_number && isColumnVisible('invoice') && <TableCell>{item.invoice_id || '—'}</TableCell>}
                                            {isColumnVisible('autopsy') && <TableCell>{item.evidence && item.evidence.autopsy ? item.evidence.autopsy : '—'}</TableCell>}
                                            <TableCell align="right" className={localClasses.actionsCell}>
                                                <div className={localClasses.actionsRow}>
                                                <ActionButton color="primary">
                                                    <Tooltip title="Zavolať">
                                                        <PhoneIcon
                                                            fontSize="small"
                                                            onClick={() => {
                                                                window.location.href = `tel:${item.ca_phone}`;
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </ActionButton>
                                                {access.write && access.seePrices && <ActionButton color={item.funeral_paid ? 'primary' : 'secondary'}>
                                                    <Tooltip title={item.funeral_paid ? "Označiť ako nezaplatený" : "Označiť ako zaplatený"}>
                                                        <EuroIcon
                                                            fontSize="small"
                                                            onClick={() => {
                                                                setConfirmDialog2({
                                                                    isOpen: true,
                                                                    title: item.funeral_paid ? 'Naozaj chcete označiť pohreb ako nezaplatený' : 'Naozaj chcete označiť pohreb ako zaplatený',
                                                                    onConfirm: () => {
                                                                        changePaidStatus(item._id);
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </ActionButton>}
                                                <ActionButton color="primary">
                                                    <Tooltip title="Detaily pohrebu">
                                                        <InfoIcon
                                                            fontSize="small"
                                                            onClick={() => {
                                                                setFuneralDetail(item._id);
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </ActionButton>
                                                {access.deleteFuneral && <ActionButton color="secondary">
                                                    <Tooltip title="Presunúť do koša">
                                                        <DeleteIcon
                                                            fontSize="small"
                                                            onClick={() => {
                                                                setConfirmDialog({
                                                                    isOpen: true,
                                                                    title: 'Presunúť tento pohreb do koša?',
                                                                    subTitle: "Pohreb môžete neskôr obnoviť.",
                                                                    onConfirm: () => {
                                                                        handleDelete(item._id)
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </ActionButton>}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </TblContainer>
                            <TblPagination/>
                            <div className={localClasses.footer}>
                                <Button size="small" className={classes.secondaryAction} onClick={handleNoLimit}>
                                    Načítať viac ako max. 100 záznamov
                                </Button>
                                <Button
                                    size="small"
                                    className={classes.secondaryAction}
                                    startIcon={<SaveIcon/>}
                                    onClick={() => {
                                        setConfirmDialog3({
                                            isOpen: true,
                                            title: 'Naozaj chcete stiahnuť všetky pohreby?',
                                            onConfirm: () => {
                                                handleDownload();
                                            }
                                        })
                                    }}
                                >
                                    Stiahnuť zálohu
                                </Button>
                            </div>
                        </>
                    )}
                </Paper>
            </Container>
                <ConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                    icon={<DeleteIcon/>}
                />
                <ConfirmDialog
                    confirmDialog={confirmDialog2}
                    setConfirmDialog={setConfirmDialog2}
                    color="primary"
                    icon={<EuroIcon/>}
                />
                <ConfirmDialog
                    confirmDialog={confirmDialog3}
                    setConfirmDialog={setConfirmDialog3}
                    color="primary"
                    year={year}
                    month={month}
                    updateYear={setYear}
                    updateMonth={setMonth}
                    dates={true}
                    icon={<SaveIcon/>}
                />
                <ConfirmDialog
                    confirmDialog={confirmDialog4}
                    setConfirmDialog={setConfirmDialog4}
                    color="primary"
                    counter={downloadCount}
                    downlaoder={downloader}
                    buttons={false}
                    icon={<SaveIcon/>}
                />
                <Popover
                    open={Boolean(columnPanelAnchor)}
                    anchorEl={columnPanelAnchor}
                    onClose={handleCloseColumnPanel}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                    transformOrigin={{vertical: 'top', horizontal: 'right'}}
                >
                    <div className={localClasses.columnPanel}>
                        <Typography className={localClasses.columnPanelTitle}>Viditeľné stĺpce</Typography>
                        <Typography className={localClasses.columnPanelHint}>
                            Vyberte stĺpce, ktoré chcete vidieť v zozname.
                        </Typography>
                        <Divider/>
                        <div className={localClasses.columnList}>
                            {columnDefinitions.map(column => {
                                const checked = isColumnVisible(column.id);
                                const disableLastVisible = checked && visibleColumns.length <= 1;

                                return (
                                    <FormControlLabel
                                        key={column.id}
                                        className={localClasses.columnOption}
                                        control={
                                            <Checkbox
                                                color="primary"
                                                checked={checked}
                                                disabled={disableLastVisible}
                                                onChange={() => handleToggleColumn(column.id)}
                                            />
                                        }
                                        label={column.label}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </Popover>
                <Popup
                    title={'Smart vyhľadávanie'}
                    openPopup={smartSearchOpen}
                    setOpenPopup={handleCloseSmartSearchModal}
                    maxW="md"
                >
                    <div className={localClasses.aiModalWrap}>
                        {smartSearchLoading && <LoadingOverlay label="Spracúvam vyhľadávanie..."/>}
                        <div className={smartSearchLoading ? localClasses.aiModalContentLoading : undefined}>
                            <Typography className={localClasses.aiNotice}>
                                Popíšte, ktoré pohreby chcete nájsť. Smart vyhľadávanie vymaže bežné filtre a použije iba AI filter.
                            </Typography>
                            <Typography className={localClasses.aiNotice}>
                                Príklady: „všetky pohreby s pitvou“, „zosnulí, ktorých meno začína na A“, „pohreby v Dome smútku v Nitre“, „nezaplatené pohreby z roku 2024“, „úmrtia v nemocnici Košice“.
                            </Typography>
                            <div style={{display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap'}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={smartSearchRecording || smartSearchLoading}
                                    onClick={startSmartSearchRecording}
                                >
                                    Spustiť nahrávanie
                                </Button>
                                <Button
                                    variant="outlined"
                                    disabled={!smartSearchRecording}
                                    onClick={stopSmartSearchRecording}
                                >
                                    Zastaviť nahrávanie
                                </Button>
                            </div>
                            {smartSearchRecording && <Typography className={localClasses.warningText}>Nahrávam...</Typography>}
                            <TextField
                                variant="outlined"
                                label="Text alebo prepis nahrávky"
                                value={smartSearchText}
                                onChange={(event) => setSmartSearchText(event.target.value)}
                                multiline
                                rows={5}
                                fullWidth
                                placeholder="Napr. všetky pohreby s pitvou v roku 2024 alebo zosnulí, ktorých meno začína na A."
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={smartSearchLoading || !smartSearchText.trim()}
                                onClick={() => applySmartSearch(smartSearchText)}
                                style={{marginTop: 16}}
                            >
                                Použiť smart vyhľadávanie
                            </Button>
                        </div>
                    </div>
                </Popup>
                <Popup
                    title={'Filtrovať podľa dátumu pohrebu'}
                    openPopup={filterModalOpen}
                    setOpenPopup={setFilterModalOpen}
                    maxW='sm'
                    actions={<>
                        <Button 
                            color="secondary" 
                            variant="outlined" 
                            onClick={handleClearFilters}
                        >
                            Vymazať filtre
                        </Button>
                        <Button 
                            color="primary" 
                            variant="outlined" 
                            onClick={() => setFilterModalOpen(false)}
                        >
                            Zrušiť
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={handleApplyFilters}
                        >
                            Použiť
                        </Button>
                    </>}
                >
                    <TextInput
                        label="Rok pohrebu"
                        placeholder="napr. 2024"
                        value={tempFilterYear}
                        onChange={(e) => setTempFilterYear(e.target.value)}
                        fullWidth
                        style={{ marginBottom: 16 }}
                    />
                    <TextInput
                        label="Mesiac pohrebu"
                        placeholder="napr. 1-12"
                        value={tempFilterMonth}
                        onChange={(e) => setTempFilterMonth(e.target.value)}
                        fullWidth
                        style={{ marginBottom: 16 }}
                    />
                    <TextInput
                        label="Týždeň pohrebu"
                        placeholder="napr. 1-52"
                        value={tempFilterWeek}
                        onChange={(e) => setTempFilterWeek(e.target.value)}
                        fullWidth
                        style={{ marginBottom: 16 }}
                    />
                    <SelectInput
                        label="Pitva"
                        value={tempFilterAutopsy}
                        options={autopsyOptions}
                        onChange={(e) => setTempFilterAutopsy(e.target.value)}
                        fullWidth
                    />
                </Popup>
                {list && <Redirect to={{
                    pathname: `/novy-pohreb`,
                    state: {from: props.location}
                }}/>}
                {funeralDetail ? <Redirect to={{
                    pathname: `/pohreb/${funeralDetail}/info`,
                    state: {from: props.location}
                }}/> : <></>}
        </React.Fragment>
    );
}
